<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center">
        <h2 class="mr-3">Update Customer</h2>
      </div>
    </div>
    <a-card>
      <a-row class="mt-4" :gutter="[32, 32]">
        <a-col :span="24" class="d-flex justify-content-between align-items-center">
          <a-button @click="$router.back()"> <LeftOutlined />Back </a-button>
        </a-col>
        <a-col :span="24">
          <div>
            <h1 class="text-title">Customer</h1>
          </div>
          <div>
            <a-row :gutter="[24, 12]">
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">ID (4 HURUF)</p>
                <a-input
                  placeholder="Masukkan Id Customer"
                  v-model:value="payload.customerSign"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Organisasi</p>
                <a-select v-model:value="payload.organizationId" style="width: 100%;">
                  <a-select-option value="" disabled>Pilih Organisasi</a-select-option>
                  <a-select-option
                    v-for="(item, idx) in organizationList"
                    :key="idx"
                    :value="item.id"
                  >
                    {{ item?.name }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Nama</p>
                <a-input
                  placeholder="Masukkan Nama Customer"
                  v-model:value="payload.name"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Email</p>
                <a-input
                  placeholder="Masukkan Email Customer"
                  v-model:value="payload.email"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Nomor Handphone</p>
                <a-input
                  placeholder="Masukkan Nomor Handphone"
                  v-model:value="payload.mobileNumber"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Nomor Kantor</p>
                <a-input
                  placeholder="Masukkan Nomor Kantor"
                  v-model:value="payload.officeNumber"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Penanggung Jawab</p>
                <a-input
                  placeholder="Masukkan Nama Penanggung Jawab"
                  v-model:value="payload.PIC"
                ></a-input>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 8 }">
                <p class="text-label">Provinsi</p>
                <a-select
                  v-model:value="payload.provinsi"
                  style="width: 100%;"
                  show-search
                  placeholder="Pilih atau cari provinsi"
                  :filter-option="false"
                  @search="fetchProvinsi"
                  @blur="fetchProvinsi('')"
                >
                  <a-select-option value="" disabled>Pilih Provinsi</a-select-option>
                  <a-select-option
                    v-for="(prov, index) in filteredProvinces"
                    :key="index"
                    :value="prov"
                  >
                    {{ prov }}
                  </a-select-option>
                </a-select>
              </a-col>

              <a-col :xs="{ span: 24 }" :sm="{ span: 12 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Latitude</p>
                  <a-input
                    placeholder="Latitude dari Peta"
                    v-model:value="payload.latitude"
                    disabled
                  ></a-input>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 12 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Longitude</p>
                  <a-input
                    placeholder="Longitude dari Peta"
                    v-model:value="payload.longitude"
                    disabled
                  ></a-input>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :sm="{ span: 24 }">
                <div class="w-100">
                  <p style="text-align: left;" class="text-label">Alamat</p>
                  <a-textarea
                    placeholder="Masukkan Alamat Customer (atau pilih dari peta)"
                    allow-clear
                    v-model:value="payload.address"
                  ></a-textarea>
                  <a-input-search
                    placeholder="Cari alamat di peta (contoh: Jl. Sudirman No. 1 Jakarta)"
                    enter-button="Cari"
                    @search="searchAddressOnMap"
                    class="mt-2"
                  />
                  <div
                    id="mapContainer"
                    style="height: 400px; width: 100%; margin-top: 10px; border-radius: 8px; overflow: hidden;"
                  ></div>
                </div>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <a-col :span="24">
          <a-row :gutter="[24, 12]">
            <a-col :span="18"></a-col>
            <a-col :span="6" class="d-flex justify-content-end align-items-center" style="gap:15px">
              <a-button @click="fetchData()">Reset</a-button>
              <a-button @click="submitPayload()" type="primary">Update</a-button>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { LeftOutlined } from '@ant-design/icons-vue'
import { notification } from 'ant-design-vue'
import { getCustomersById, putCustomers } from '../../services/axios/modc/customer'
import { getOrganizations } from '../../services/axios/modc/organization'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  components: { LeftOutlined },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const payload = ref({}) // Di-inisialisasi kosong, akan diisi oleh fetchData
    const provinces = ref([
      'Aceh',
      'Sumatera Utara',
      'Sumatera Barat',
      'Riau',
      'Jambi',
      'Sumatera Selatan',
      'Bengkulu',
      'Lampung',
      'Kepulauan Bangka Belitung',
      'Kepulauan Riau',
      'DKI Jakarta',
      'Jawa Barat',
      'Jawa Tengah',
      'DI Yogyakarta',
      'Jawa Timur',
      'Banten',
      'Bali',
      'Nusa Tenggara Barat',
      'Nusa Tenggara Timur',
      'Kalimantan Barat',
      'Kalimantan Tengah',
      'Kalimantan Selatan',
      'Kalimantan Timur',
      'Kalimantan Utara',
      'Sulawesi Utara',
      'Sulawesi Tengah',
      'Sulawesi Selatan',
      'Sulawesi Tenggara',
      'Gorontalo',
      'Sulawesi Barat',
      'Maluku',
      'Maluku Utara',
      'Papua',
      'Papua Barat Daya',
      'Papua Barat',
      'Papua Selatan',
      'Papua Tengah',
      'Papua Pegunungan',
    ])
    const filteredProvinces = ref([])
    const organizationList = ref([])
    let map = null
    let marker = null

    const initializeMap = () => {
      const initialCoords =
        payload.value.latitude && payload.value.longitude
          ? [payload.value.latitude, payload.value.longitude]
          : [-6.2088, 106.8456] // Default ke Jakarta
      const initialZoom = payload.value.latitude ? 16 : 13
      map = L.map('mapContainer').setView(initialCoords, initialZoom)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map)
      map.on('click', onMapClick)
      if (payload.value.latitude && payload.value.longitude) {
        setMarker(payload.value.latitude, payload.value.longitude)
      }
    }

    const fetchOrganizations = async () => {
      const { organization } = await getOrganizations()
      organizationList.value = organization
    }

    const fetchData = async () => {
      try {
        const { customer } = await getCustomersById(route.params.id)
        if (customer && customer.length > 0) {
          payload.value = { ...customer[0] }
          if (map) {
            // Pastikan peta sudah ada sebelum memanipulasinya
            const newCoords =
              payload.value.latitude && payload.value.longitude
                ? [payload.value.latitude, payload.value.longitude]
                : [-6.2088, 106.8456]
            map.setView(newCoords, payload.value.latitude ? 16 : 13)
            if (payload.value.latitude && payload.value.longitude) {
              setMarker(payload.value.latitude, payload.value.longitude)
            } else if (marker) {
              map.removeLayer(marker)
              marker = null
            }
          }
        }
      } catch (error) {
        notification.error({ message: 'Gagal', description: 'Gagal memuat data customer.' })
      }
    }

    onMounted(async () => {
      // Inisialisasi peta terlebih dahulu
      initializeMap()
      // Kemudian ambil data organisasi dan data customer
      await fetchOrganizations()
      await fetchData()
      fetchProvinsi()
    })

    const onMapClick = async e => {
      const { lat, lng } = e.latlng
      payload.value.latitude = lat
      payload.value.longitude = lng
      setMarker(lat, lng)
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=id`,
        )
        const data = await response.json()
        payload.value.address = data.display_name || `Koordinat: ${lat}, ${lng}`
      } catch (error) {
        notification.error({
          message: 'Error Geocoding',
          description: 'Gagal mendapatkan alamat dari koordinat.',
        })
      }
    }

    const setMarker = (lat, lng) => {
      if (marker) {
        marker.setLatLng([lat, lng])
      } else {
        marker = L.marker([lat, lng]).addTo(map)
      }
    }

    const searchAddressOnMap = async address => {
      if (!address) {
        notification.warn({
          message: 'Peringatan',
          description: 'Mohon masukkan alamat untuk mencari.',
        })
        return
      }
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
            address,
          )}&accept-language=id`,
        )
        const data = await response.json()
        if (data && data.length > 0) {
          const { lat, lon, display_name } = data[0]
          payload.value.latitude = parseFloat(lat)
          payload.value.longitude = parseFloat(lon)
          payload.value.address = display_name
          setMarker(parseFloat(lat), parseFloat(lon))
          map.setView([parseFloat(lat), parseFloat(lon)], 16)
          notification.success({ message: 'Alamat Ditemukan' })
        } else {
          notification.error({ message: 'Alamat Tidak Ditemukan' })
        }
      } catch (error) {
        notification.error({ message: 'Error Pencarian Alamat' })
      }
    }

    const fetchProvinsi = value => {
      // Logika untuk filter provinsi
      filteredProvinces.value = provinces.value.filter(prov =>
        prov.toLowerCase().includes((value || '').toLowerCase()),
      )
    }

    const submitPayload = async () => {
      try {
        const data = await putCustomers(payload.value, route.params.id)
        if (data) {
          notification.success({
            message: 'Berhasil Update',
            description: 'Data Customer berhasil diperbarui.',
          })
          router.push('/customers')
        }
      } catch (error) {
        notification.error({
          message: 'Gagal Update',
          description: error.response?.data?.message || 'Terjadi kesalahan internal pada server.',
        })
      }
    }

    return {
      payload,
      submitPayload,
      fetchData,
      searchAddressOnMap,
      organizationList,
      filteredProvinces,
      fetchProvinsi,
    }
  },
}
</script>

<style lang="scss">
@import '../styleViews.scss';

.text-title {
  font-size: 1.5rem;
  color: $black;
  font-weight: 500;
  margin-bottom: 10px;
}

.text-subtitle {
  font-size: 1.3rem;
  color: $black;
  font-weight: 500;
  margin-bottom: 10px;
}

.text-label {
  font-size: 1rem;
  color: $text;
  font-weight: 400;
  margin-bottom: 10px;
}

.th-upload-wrapper {
  .ant-upload-picture-card-wrapper {
    display: flex;
    justify-content: center;

    .ant-upload {
      width: 300px;
      height: 100px;
    }
  }
}
</style>
